import { mapGetters } from 'vuex'
import { types as STORE_MODULES } from '@/js/plugins/store/store-modules.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'
import { HUBSPOT_BRAND_WHITELIST } from '@/js/components/HubSpot/Helpers/hubspot-constants.js'
import { createDynamicScriptTag } from '@/js/components/HubSpot/Helpers/hubspot-helper.js'

export default {
  methods: {
    createDynamicScriptTag,
  },
  computed: {
    ...mapGetters(STORE_MODULES.APP, {
      companyBrands: APP_GETTER.USER_BRANDS,
    }),
    brands() {
      return (
        this.companyBrands.length
          ? this.companyBrands
          : HUBSPOT_BRAND_WHITELIST.map(i => ({ long: i }))
      )
        .filter(({ long }) => {
          return HUBSPOT_BRAND_WHITELIST.includes(long)
        })
        .map(({ long }) => long)
    },
  },
}
